import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import NewQueryTool from '@containers/DigitalAnalyst/NewQueryTool';
import { AI_TOOLS, DOC_SELECT_MODES } from '@constants';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.RFP_RESPONSE;

function RfpResponseQuery() {
  const navigate = useNavigate();
  const [docModes] = React.useState([DOC_SELECT_MODES.docType, DOC_SELECT_MODES.companyTag]);
  const [defaultActiveDocSelectMode] = React.useState(DOC_SELECT_MODES.docType);

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <NewQueryTool
          docModes={docModes}
          defaultActiveDocSelectMode={defaultActiveDocSelectMode}
          heading="RFP Q&A"
          onGoBack={onGoBack}
          isRFPMode
          tool={tool}
        />
      </Body>
    </PageWrapper>
  );
}

export default RfpResponseQuery;
